import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const reportGeneration = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '报告状态',
            dataIndex: 'reportStatus',
            key: 'reportStatus',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'reportStatus'
            },
            filteredValue: filteredInfo.reportStatus || [],
        },
        {
            title: '委托方',
            dataIndex: 'client',
            key: 'client',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.client || [],
        },
        {
            title: '项目联系人',
            dataIndex: 'projectContact',
            key: 'projectContact',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.projectContact || [],
        },
        {
            title: '合同号',
            dataIndex: 'contractNo',
            key: 'contractNo',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractNo || [],
        },
        {
            title: '是否添加水印',
            dataIndex: 'watermarkFlag',
            key: 'watermarkFlag',
            scopedSlots: {
                filterDropdown: 'filterFlag',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'watermarkFlag'
            },
            filteredValue: filteredInfo.watermarkFlag || [],
        },
        {
            title: '项目类型',
            dataIndex: 'reportProjectType',
            key: 'reportProjectType',
            scopedSlots: {
                filterDropdown: 'filterReportProjectType',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'reportProjectType'
            },
            filteredValue: filteredInfo.reportProjectType || [],
        },
        {
            title: '具体类型',
            dataIndex: 'concreteType',
            key: 'concreteType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'concreteType'
            },
            filteredValue: filteredInfo.concreteType || [],
        },
        {
            title: '报告名称',
            dataIndex: 'reportName',
            key: 'reportName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportName || [],
        },
        {
            title: '样品数量',
            dataIndex: 'numberOfSamples',
            key: 'numberOfSamples',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfSamples || [],
        },
        {
            title: '数据量',
            dataIndex: 'dataVolume',
            key: 'dataVolume',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.dataVolume || [],
        },
        {
            title: '报告后缀',
            dataIndex: 'reportSuffix',
            key: 'reportSuffix',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportSuffix || [],
        },
        {
            title: '报告公司',
            dataIndex: 'reportCompany',
            key: 'reportCompany',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportCompany || [],
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        }
    ]
}
